import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  Inject,
  OnInit,
} from '@angular/core';
import { FilesInputComponent } from '@shared/components/forms/files-input/files-input.component';
import { mimeTypes } from '@shared/constants/mime-types';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TuiButtonModule, TuiDialogContext } from '@taiga-ui/core';
import {
  catchError,
  EMPTY,
  map,
  merge,
  Subject,
  switchMap,
  tap,
  throwError,
} from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InvoiceService } from '@shared/services/invoice.service';
import { AlertService } from '@shared/services/alert.service';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { ClientFormInputData } from '@shared/components/catalogs/client-form/client-form.component';

@Component({
  selector: 'app-upload-accounting-invoices',
  standalone: true,
  imports: [FilesInputComponent, ReactiveFormsModule, TuiButtonModule],
  templateUrl: './upload-accounting-invoices.component.html',
  styleUrl: './upload-accounting-invoices.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadAccountingInvoicesComponent implements OnInit {
  protected readonly mimeTypes = mimeTypes;

  files = this.fb.nonNullable.control<File[]>([], {
    validators: [Validators.required],
  });

  upload$ = new Subject<void>();

  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    protected readonly context: TuiDialogContext<void, ClientFormInputData>,
    private readonly fb: FormBuilder,
    private readonly destroyRef: DestroyRef,
    private readonly invoiceService: InvoiceService,
    private readonly alert: AlertService,
  ) {}

  onUpload() {
    return this.upload$.pipe(
      map(() => this.files.getRawValue()),
      switchMap(files => {
        if (!files.length) {
          return throwError(() => new Error('Empty files'));
        }
        return this.invoiceService.handleAccountingInvoices(files).pipe(
          tap(() => {
            this.alert.showSuccess('Файлы отправлены в обработку');
            this.close();
          }),
          catchError(err => {
            this.alert.showError(err.error);
            return EMPTY;
          }),
        );
      }),
    );
  }

  ngOnInit() {
    merge(this.onUpload())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  protected close() {
    this.context.$implicit.complete();
  }
}
